import { useQuery } from 'hooks/useCustomQuery';
import getTrunkTypesForCompany from 'API/Company/getTrunkTypesForCompany';

/**
 * Every trunk type creatable on the company, across all platforms.
 *
 * @param {object} params
 * @param {string} params.companyID
 */
const useGetCompanyTrunkTypes = ({ companyID }) => {
    return useQuery({
        queryKey: ['companyTrunkTypes', companyID],
        queryFn: async () => {
            const res = await getTrunkTypesForCompany(companyID);
            return res?.data || [];
        },
        enabled: Boolean(companyID),
    });
};

export default useGetCompanyTrunkTypes;
